import { render, staticRenderFns } from "./SelectTypeAnswersContent.vue?vue&type=template&id=0dd8d2de"
import script from "./SelectTypeAnswersContent.vue?vue&type=script&lang=js"
export * from "./SelectTypeAnswersContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports